/* eslint-disable */
// 数组和对象数组去重
const arrayUnique = (arr, choose) => {
  if (Array.isArray([])) {
    if (arr.some(el => typeof el === "object")) {
      console.log("对象");
      arr.reduce((pre, curr) => {
        console.log("pre", pre);
        console.log("curr", curr);
        const find = pre.find(i => i[choose] === curr[choose]);
        if (!find) pre.push(curr);
        return pre;
      }, []);
    } else {
      const res = new Set(arr);
      return [...res];
    }
  }
  return [];
};

/**
 * [过滤对象]
 * @param  obj [过滤前数据]
 * @param  arr [过滤条件，要求为数组]
 */
const filterObj = (obj, arr) => {
  if (typeof obj !== "object" || !Array.isArray(arr)) {
    throw new Error("参数格式不正确");
  }
  const result = {};
  Object.keys(obj)
    .filter(key => arr.includes(key))
    .forEach(key => {
      result[key] = obj[key];
    });
  return result;
};

const isEmptyObj = obj => !Object.keys(obj).length;

// 导出 函数节流 在指定的时间间隔内只执行一次任务
// eslint-disable-next-line no-unused-vars
function throttle(fn, delay) {
  let last;
  let timer;
  return function() {
    const that = this;
    // eslint-disable-next-line prefer-rest-params
    const _args = arguments;
    const now = +new Date();
    if (last && now < last + delay) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(that, _args);
      }, delay);
    } else {
      last = now;
      fn.apply(that, _args);
    }
  };
}

// eslint-disable-next-line no-unused-vars
function debounce(fn, delay) {
  let timer = null;
  // eslint-disable-next-line no-redeclare,no-var
  var delay = delay || 200;
  return function() {
    const that = this;
    // eslint-disable-next-line prefer-rest-params
    const _args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(that, _args);
    }, delay);
  };
}

function isAndroid() {
  const u = navigator.userAgent;
  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    return true;
  }
  return false;
} // g
function isIOS() {
  const u = navigator.userAgent;
  if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    return true;
  }
  return false;
} // ios终端

// xhq 2020-09-28 14:25:30
function isNull(val) {
  if (val === null || val === undefined || val === "") {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

/**
 * 对象深拷贝
 * @param  obj 对象
 */
function cloneObj(obj) {
  let str;
  let newObj = obj.constructor === Array ? [] : {};
  if (
    Object.prototype.toString.call(obj) !== "[object Object]" &&
    Object.prototype.toString.call(obj) !== "[object Array]"
  ) {
    return;
  }
  if (window.JSON) {
    str = JSON.stringify(obj); // 系列化对象
    newObj = JSON.parse(str); // 还原
  } else {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const i in obj) {
      newObj[i] = typeof obj[i] === "object" ? this.cloneObj(obj[i]) : obj[i];
    }
  }
  // eslint-disable-next-line consistent-return
  return newObj;
}

/**
 * @function deepCopy 浅深拷贝
 * @param  {type} obj {description}
 * @return {type} {description}
 */
function deepCopy(obj) {
  return JSON.parse(JSON.stringify(obj));
}

// xhq 2020-10-15 16:07:05 因为预生产，生产的运维脚本 是拷贝dist文件不是重新打包，所以先用window.env process.env只是兼容本地开发
const getEnv = () => process.env;

// 修改标题
const changeTitle = title => {
  document.title = title;
};

function isAPPEnvironment() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.indexOf("fromapp") > -1;
}

// 日期格式化
const dateFormat = (fmt, date, isweek = false) => {
  date = new Date(date);
  let ret;
  const weekday = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  const opt = {
    "Y+": date.getFullYear().toString(), // 年
    "m+": (date.getMonth() + 1).toString(), // 月
    "d+": date.getDate().toString(), // 日
    "H+": date.getHours().toString(), // 时
    "M+": date.getMinutes().toString(), // 分
    "S+": date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (const k in opt) {
    ret = new RegExp(`(${k})`).exec(fmt);
    if (ret) {
      fmt = fmt.replace(
        ret[1],
        ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
      );
    }
  }
  if (isweek) {
    fmt = `${fmt}  ${weekday[date.getDay()]}`;
  }
  return fmt;
};

const formatDuring = time => {
  let hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = parseInt((time % (1000 * 60)) / 1000);
  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${hours}:${minutes}:${seconds}`;
};

// 腾讯云图片压缩
const setPictureThumbnail = (imgUrl, size) => {
  if (!imgUrl) return "";
  if (!size) size = "700";
  const TxPicThumbnail = `imageMogr2/thumbnail/${size}x`;
  if (imgUrl.includes("?")) {
    return `${imgUrl}&${TxPicThumbnail}`;
  }
  return `${imgUrl}?${TxPicThumbnail}`;
};

/**
 * 获取原生路由地址
 * @param routeObj : { ios: ios路由, android: 安卓路由 }
 */
const getNativeUrl = routeObj => {
  let url = "";
  if (isIOS()) url = routeObj.ios;
  if (isAndroid()) url = routeObj.android;
  return url;
};

/**
 * 获取滚动条距离底部高度
 */
function getScrollBottomHeight() {
  const dd = document.documentElement;
  const db = document.body;
  const scrollTop = dd.scrollTop || db.scrollTop; // 滚动条高度
  const clientHeight = dd.clientHeight || db.clientHeight; // 视窗高度
  const scrollHeight = dd.scrollHeight || db.scrollHeight; // 文档内容高度
  const h = scrollHeight - scrollTop - clientHeight;
  return h;
}

/**
 * 设置滚动条高度
 * @param h 高度
 * @param querySelector 设置滚动条高度的容器
 */
function setScrollBarHeight(h, querySelector) {
  if (querySelector) {
    querySelector.scrollTop = h;
  } else {
    document.documentElement.scrollTop = h;
    document.body.scrollTop = h;
  }
}

/**
 * 腾讯云图片压缩（png格式图片有透明背景需要传format: "png"）
 * @param obj 压缩参数 { url: 图片链接, width: 宽度, height: 高度, quality: 质量（取值1-100）, format: 图片格式（jpg，bmp，gif，png，webp） }
 */
function setPicCompress(obj) {
  let imgUrl = obj.url;

  if (imgUrl?.includes("?")) {
    imgUrl += `&imageView2/2`;
  } else {
    imgUrl += `?imageView2/2`;
  }

  if (obj.width) imgUrl += `/w/${obj.width}`;
  if (obj.height) imgUrl += `/h/${obj.height}`;
  imgUrl += `/q/${obj.quality ? obj.quality : 85}`;
  imgUrl += `/format/${obj.format ? obj.format : "jpg"}`;

  return imgUrl;
}

/**
 * 手动埋点
 * @param eventname 埋点事件名
 * @param data 埋点数据
 */
function trackEvent(eventname, data) {
  if (window.AFL && typeof window.AFL === "object")
    window?.AFL?.CCQCTrack(eventname, data);
}

export {
  arrayUnique,
  filterObj,
  isEmptyObj,
  throttle,
  debounce,
  isAndroid,
  isIOS,
  isNull,
  isEmptyObject,
  cloneObj,
  deepCopy,
  getEnv,
  changeTitle,
  dateFormat,
  formatDuring,
  isAPPEnvironment,
  setPictureThumbnail,
  getNativeUrl,
  getScrollBottomHeight,
  setScrollBarHeight,
  setPicCompress,
  trackEvent
};

export default {
  arrayUnique,
  filterObj,
  isEmptyObj,
  throttle,
  debounce,
  isAndroid,
  isIOS,
  isNull,
  isEmptyObject,
  cloneObj,
  deepCopy,
  getEnv,
  changeTitle,
  dateFormat,
  formatDuring,
  isAPPEnvironment,
  setPictureThumbnail,
  getNativeUrl,
  getScrollBottomHeight,
  setScrollBarHeight,
  setPicCompress,
  trackEvent
};
